export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-no-dd9c31c6.svg'